module.exports = __webpack_public_path__ + "static/media/21ECLAC47.47633905.jpg";